import script from "./ArchiveTree.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchiveTree.vue?vue&type=script&setup=true&lang=js"

import "./ArchiveTree.vue?vue&type=style&index=0&id=38257031&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38257031"]])

export default __exports__